const getStepEvaluations = (
  index: number,
  currentStepIndex: number
): { isPreviousOrCurrentStep: boolean; isPreviousStep: boolean; stepNumber: number } => {
  const isPreviousOrCurrentStep = currentStepIndex >= index;
  const isPreviousStep = currentStepIndex > index;
  return { isPreviousOrCurrentStep, isPreviousStep, stepNumber: index + 1 };
};
export default getStepEvaluations;
